import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Pipe, PipeTransform} from "@angular/core";
import {ApiConfigService} from "../../../shared-services/api-config.service";

@Pipe({
    name: 'secure'
})
export class SecurePipe implements PipeTransform {

    constructor(private http: HttpClient, private apiConfigService: ApiConfigService) { }

    transform(url: string) {

        return new Observable<any>((observer) => {
            // This is a tiny blank image
            observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

            // The next and error callbacks from the observer
            const {next, error} = observer;

            this.apiConfigService.get(url, null,{responseType: 'blob'}).subscribe(response => {
                const reader = new FileReader();
                reader.readAsDataURL(response as any);
                reader.onloadend = function() {
                    observer.next(reader.result);
                };
            });

            return {unsubscribe() {  }};
        });
    }
}